(() => {
  if (window.funtoTvcInitialized) return;
  window.funtoTvcInitialized = true;
  function init(root = document) {
    root.querySelectorAll('[data-funto-tvc]:not([data-funto-tvc-ready])').forEach((element) => {
      element.dataset.funtoTvcReady = 'true';
      const mount = element.querySelector('[data-funto-tvc-player]');
      const button = element.querySelector('[data-funto-tvc-play]');
      if (!mount || !button || !/^[a-zA-Z0-9_-]{11}$/.test(element.dataset.videoId || '')) return;
      button.addEventListener('click', () => {
        if (button.disabled) return;
        button.disabled = true;
        const frame = document.createElement('iframe');
        frame.title = element.dataset.videoTitle || button.getAttribute('aria-label') || 'YouTube';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.style.visibility = 'hidden';
        let timeout;
        let settled = false;
        const restore = () => {
          if (settled) return;
          settled = true;
          clearTimeout(timeout);
          frame.remove();
          button.hidden = false;
          button.disabled = false;
        };
        frame.addEventListener('load', () => {
          if (settled) return;
          settled = true;
          clearTimeout(timeout);
          frame.style.visibility = 'visible';
          button.hidden = true;
          frame.focus();
        }, { once: true });
        frame.addEventListener('error', restore, { once: true });
        frame.src = `https://www.youtube-nocookie.com/embed/${element.dataset.videoId}?autoplay=1&playsinline=1&controls=1&rel=0`;
        timeout = setTimeout(restore, 15000);
        mount.replaceChildren(frame);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
